
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';
import InvoiceService from '@/services/invoice.service';

@Component({})
export default class screenShop extends Vue {
  visible = false;

  title = '门店筛选';

  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Prop()
  typeOrder!: string;

  columns = [
    {
      title: '店铺名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 200,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 200,
    },
    {
      title: '城市',
      dataIndex: 'province',
      key: 'province',
      align: 'center',
      width: 200,
    },
  ];

  data = [];

  form: any = {
    ka_id: '',
    shop_name: '',
    page: 1,
    pageSize: 20,
    verify_time_start: '',
    verify_time_end: '',
  };

  pagination = {
    pageSize: 20,
    total: 0,
    current: 1,
    onChange: this.onChangePage,
  };

  selectedRowKeys: string[] = [];

  onSelectChange(selectedRowKeys: string[]) {
    // console.log(selectedRowKeys);
    this.selectedRowKeys = selectedRowKeys;
  }

  init(data: any) {
    this.form.ka_id = data.ka_id;
    this.form.verify_time_start = data.verify_time_start;
    this.form.verify_time_end = data.verify_time_end;
    this.getShopList(this.form);
    this.visible = true;
    if (data.shop_id) {
      this.selectedRowKeys = data.shop_id
        .split(',')
        .map((item: string) => Number(item));
    } else {
      this.selectedRowKeys = [];
    }
  }

  async getShopList(params: any) {
    let res: any;
    if (this.typeOrder === '1') {
      res = await this.invoiceService.getInvoiceCommissionOrderShops(params);
    } else {
      res = await this.invoiceService.getInsuranceBillsShops(params);
    }
    this.data = res.list;
    this.pagination.total = res.total;
    this.pagination.current = res.page;
  }

  onChangePage(page: number, pageSize: number) {
    this.form.page = page;
    this.form.page_size = pageSize;
    this.getShopList(this.form);
  }
  handleSearch() {
    this.form.page = 1;
    this.getShopList(this.form);
  }
  handleReset() {
    this.form.shop_name = '';
    this.form.page = 1;
    this.form.page_size = 20;
    this.getShopList(this.form);
  }
  handleOk() {
    this.visible = false;
    this.$emit('select', this.selectedRowKeys);
  }

  handleCancel() {
    this.visible = false;
  }
}
